export const NavSidebar = {
  flow: 'y',
  width: 'F2',
  background: 'inkMid',
  borderRight: '1px solid inkBorder',
  padding: 'A 0 0 0',
  height: '100vh',
  position: 'sticky',
  top: '0',
  overflow: 'auto',
  '@mobileL': { display: 'none' },

  LogoArea: {
    padding: '0 A Z A',
    marginBottom: 'Z',
    borderBottom: '1px solid inkBorder',
    LogoLink: {
      extends: 'Link',
      href: '/dashboard',
      textDecoration: 'none',
      flow: 'x',
      align: 'center flex-start',
      gap: 'W',
      LogoIcon: {
        extends: 'Icon',
        icon: 'fourStar',
        width: 'A',
        height: 'A',
        color: 'inkText'
      },
      LogoText: {
        text: 'MCAI',
        fontSize: 'A',
        fontWeight: '700',
        color: 'inkText',
        letterSpacing: '-0.02em'
      }
    }
  },

  MainNav: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    NavDashboard: {
      extends: 'SidebarNavItem',
      state: {
        route: '/dashboard',
        label: '{{ navDashboard | polyglot }}',
        iconName: 'home'
      }
    },
    NavPatients: {
      extends: 'SidebarNavItem',
      state: {
        route: '/patients',
        label: '{{ navPatients | polyglot }}',
        iconName: 'users'
      }
    }
  },

  ClinicalSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    SectionLabel1: {
      text: '{{ sectionClinical | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavScheduling: {
      extends: 'SidebarNavItem',
      state: {
        route: '/scheduling',
        label: '{{ navScheduling | polyglot }}',
        iconName: 'calendar'
      }
    },
    NavMySchedule: {
      extends: 'SidebarNavItem',
      state: { route: '/my-schedule', label: 'My Schedule', iconName: 'user' }
    },
    NavRadiology: {
      extends: 'SidebarNavItem',
      state: {
        route: '/radiology',
        label: '{{ navRadiology | polyglot }}',
        iconName: 'aperture'
      }
    },
    NavDocuments: {
      extends: 'SidebarNavItem',
      state: {
        route: '/documents',
        label: '{{ navDocuments | polyglot }}',
        iconName: 'fileText'
      }
    }
  },

  TemplatesSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    borderTop: '1px solid inkBorder',
    SectionLabelTpl: {
      text: 'Templates',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavTemplates: {
      extends: 'SidebarNavItem',
      state: { route: '/templates', label: 'Record Templates', iconName: 'copy' }
    },
    NavFormBuilder: {
      extends: 'SidebarNavItem',
      state: { route: '/templates/forms', label: 'Form Builder', iconName: 'edit' }
    },
    NavConsentTpl: {
      extends: 'SidebarNavItem',
      state: { route: '/templates/consent', label: 'Consent Templates', iconName: 'checkSquare' }
    }
  },

  OpsSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    SectionLabel2: {
      text: '{{ sectionOperations | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavFinances: {
      extends: 'SidebarNavItem',
      state: {
        route: '/finances',
        label: '{{ navFinances | polyglot }}',
        iconName: 'dollarSign'
      }
    },
    NavBilling: {
      extends: 'SidebarNavItem',
      state: {
        route: '/billing',
        label: '{{ navBilling | polyglot }}',
        iconName: 'creditCard'
      }
    },
    NavInventory: {
      extends: 'SidebarNavItem',
      state: {
        route: '/inventory',
        label: '{{ navInventory | polyglot }}',
        iconName: 'package'
      }
    },
    NavRx: {
      extends: 'SidebarNavItem',
      state: {
        route: '/prescriptions',
        label: '{{ navPrescriptions | polyglot }}',
        iconName: 'rx'
      }
    },
    NavLab: {
      extends: 'SidebarNavItem',
      state: {
        route: '/lab-cases',
        label: '{{ navLabCases | polyglot }}',
        iconName: 'flask'
      }
    },
    NavReferrals: {
      extends: 'SidebarNavItem',
      state: {
        route: '/referrals',
        label: '{{ navReferrals | polyglot }}',
        iconName: 'send'
      }
    },
    NavStaff: {
      extends: 'SidebarNavItem',
      state: { route: '/staff', label: 'Staff', iconName: 'users' }
    }
  },

  CommSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    SectionLabel3: {
      text: '{{ sectionComm | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavChat: {
      extends: 'SidebarNavItem',
      state: {
        route: '/chat',
        label: '{{ navChat | polyglot }}',
        iconName: 'messageSquare'
      }
    }
  },

  AnalyticsSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    SectionLabel4: {
      text: '{{ sectionAnalytics | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavReports: {
      extends: 'SidebarNavItem',
      state: {
        route: '/reports',
        label: '{{ navReports | polyglot }}',
        iconName: 'barChart'
      }
    }
  },

  AiSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    borderTop: '1px solid inkBorder',
    SectionLabel5: {
      text: '{{ sectionAiTools | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavAi: {
      extends: 'SidebarNavItem',
      state: {
        route: '/ai',
        label: '{{ aiAssistant | polyglot }}',
        iconName: 'sparkle'
      }
    }
  },

  AdminSection: {
    flow: 'y',
    gap: 'X',
    padding: 'Z Z',
    borderTop: '1px solid inkBorder',
    SectionLabel6: {
      text: '{{ sectionAdmin | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'gold',
      letterSpacing: 'X',
      padding: 'Y Z',
      textTransform: 'uppercase'
    },
    NavIntegrations: {
      extends: 'SidebarNavItem',
      state: {
        route: '/integrations',
        label: '{{ navIntegrations | polyglot }}',
        iconName: 'link'
      }
    },
    NavEnterprise: {
      extends: 'SidebarNavItem',
      state: {
        route: '/enterprise',
        label: '{{ navEnterprise | polyglot }}',
        iconName: 'shield'
      }
    }
  },

  BottomBar: {
    flow: 'x',
    align: 'center space-between',
    padding: 'Z A',
    borderTop: '1px solid inkBorder',
    marginTop: 'auto',
    flexShrink: '0',
    VersionText: { text: 'v2.0', fontSize: 'Y', color: 'inkMuted' },
    ThemeToggle: {}
  }
}
